"use client";
import { FC } from "react";
import { getDataAutomationId, getDataLinkAttributes } from "@/helpers";
import cn from "classnames";
import Link from "@/components/Link";
import type { LinkProps } from "./SWDCGlobalSimpleFooter";
declare global {
  interface Window {
    Optanon?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export type NewGlobalSimpleFooterProps = {
  legal_links: Array<LinkProps>;
  copyright: string;
  animatedTopLine: boolean;
};

export const NewGlobalSimpleFooter: FC<NewGlobalSimpleFooterProps> = ({
  legal_links,
  copyright,
  animatedTopLine,
}) => {
  return (
    <footer className="bg-background mt-auto overflow-x-hidden">
      {animatedTopLine && <div className="footer-gradient-line" />}
      <ul className="swdc-container border-t-swdc-warm-gray-100 text-swdc-gray-250 font-geist text-body-2xs flex flex-wrap gap-5 border-t p-6">
        {legal_links.map(
          (
            { title, href, isDoNotSellLink, doNotSellAriaLabel, dlt, dld },
            index,
          ) => (
            <li
              key={`${title}-${index}`}
              className={cn(
                "pr-5 last:pr-0",
                index !== legal_links.length - 1 &&
                  "border-warm-gray-100 border-r",
              )}
            >
              {isDoNotSellLink ? (
                <button
                  type="button"
                  aria-label={doNotSellAriaLabel || title}
                  onClick={() => {
                    if (window && window.Optanon) {
                      window.Optanon.ToggleInfoDisplay();
                    }
                  }}
                  {...getDataLinkAttributes({
                    dlt: dlt || "Footer",
                    dld: dld || `${title} link`,
                  })}
                  {...getDataAutomationId("legal-link")}
                  className="focus-visible:outline-swdc-blue-325 active:text-swdc-gray-200 hover:text-body-secondary outline-none hover:underline focus-visible:rounded-xs focus-visible:outline-2 focus-visible:outline-solid active:underline"
                >
                  {title}
                </button>
              ) : (
                <Link
                  href={href}
                  {...getDataLinkAttributes({
                    dlt: dlt || "Footer",
                    dld: dld || `${title} link`,
                  })}
                  {...getDataAutomationId("legal-link")}
                  className="focus-visible:outline-swdc-blue-325 active:text-swdc-gray-200 hover:text-body-secondary outline-none hover:underline focus-visible:rounded-xs focus-visible:outline-2 focus-visible:outline-solid active:underline"
                >
                  {title}
                </Link>
              )}
            </li>
          ),
        )}
      </ul>
      <div className="bg-swdc-warm-gray-100 text-swdc-warm-gray-450 text-body-2xs font-geist">
        <p className="swdc-container p-6 leading-6">{copyright}</p>
      </div>
    </footer>
  );
};

export default NewGlobalSimpleFooter;
